import { render, staticRenderFns } from "./IcoArrowRightCircle.vue?vue&type=template&id=0a808b46"
import script from "./IcoArrowRightCircle.vue?vue&type=script&lang=js"
export * from "./IcoArrowRightCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports